import { ProofOfDeliveryItem } from '../../../delivery-note/models/delivery-note-proof-of-delivery.model';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { mustNotBeBlankValidator } from '../../../../../common';

export class PublicProofOfDeliveryItem extends ProofOfDeliveryItem {
  deliveryNoteNumber: string = null;

  constructor(params?: PublicProofOfDeliveryItem) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class PublicProofOfDeliveryFeedbackForm {
  constructor(
    fb: FormBuilder = new FormBuilder(),
    public text: FormControl<string> = fb.control<string>(null, [Validators.required, mustNotBeBlankValidator]),
  ) {}
}
